import { render, staticRenderFns } from "./pending-approval.vue?vue&type=template&id=1a8a525a&"
import script from "./pending-approval.vue?vue&type=script&lang=js&"
export * from "./pending-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports